
import { defineComponent, inject, ref, Ref } from 'vue';
import DsCookies from './DsCookies';
import VueScrollTo from 'vue-scrollto';

const { slideDown, slideUp } = window.domSlider;

export default defineComponent({
  setup() {
    const cookies: DsCookies | undefined = inject('cookies');
    const details:Ref<HTMLElement|null> = ref(null);
    let isDetailOpen = false;

    const toggleDetails = () => {
      if (details.value) {
        if (isDetailOpen) {
          slideUp({
            element: details.value
          });
          isDetailOpen = false;
        } else {
          slideDown({
            element: details.value,
            slideSpeed: 0
          }).then(() => {
            VueScrollTo.scrollTo(details.value, 500, {
              container: details.value?.parentElement
            });
          });

          isDetailOpen = true;
        }
      }
    }

    if (!cookies) {
      return;
    }

    return {
      cookies,
      details,
      toggleDetails
    };
  }
});
